import { useState, useEffect, useRef, useMemo } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import BackButton from '../../Shared/BackButton'
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const MessageBalanceDetail = () => {
    const [title, setTitle] = useState('');
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state) {
            const {payload} = location.state
            fetchData(payload);
            setTitle(`Message Balance Detail From ${payload.fdate} To ${payload.tdate}`)
        }

    }, [])

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/messages/balance-detail/?fdate=${payload.fdate}&tdate=${payload.tdate}&branch_id=${payload?.branch_id}`)
            setData(response?.data)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error?.response?.data?.detail || 'Forbidden');
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to load message balance detail')
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Opening",
            field: "opening",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Debit",
            field: "debit",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Credit",
            field: "credit",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            filter: true,
        },
    ], []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <BackButton
                    to="/sms-balance"
                    state={{ fdate: location.state?.payload?.fdate, tdate: location.state?.payload?.tdate, by: location.state?.payload?.by }}
                    label="Back to Summary"
                />
            </div>
        </div>
        <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            suppressMenuHide={true}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            defaultColDef={defaultColDef}
                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                            animateRows={true}
                            pagination={false}

                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}


                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
        </div>
        </div>
      <br/>
    </>
  )
}

export default MessageBalanceDetail